export enum ConfigContactType {
    Email = 0,
    PhoneNumber = 1,
}
